export default [
    'What did {{ firstName }} do well?',
    'What could {{ firstName }} improve on?',
    "What is {{ firstName }}'s key strength?",
];
